module.exports = __webpack_public_path__ + "img/sort.d02ecf8b.svg";